import { Filter, FilterTypes } from 'src/api/types';

export const querifiedFilters = (filters: Filter[]): string => {
  return filters
    .map((filter) => {
      const stringifiedFilterValues =
        filter?.selectedValues
          ?.map((value) => {
            return value;
          })
          .filter((n) => n)
          .join('$') || null;

      if (!stringifiedFilterValues || stringifiedFilterValues === '') {
        return '';
      }

      return `${filter.id}§${filter.type}${
        stringifiedFilterValues ? `§${stringifiedFilterValues}` : ''
      }`;
    })
    .filter((n) => n)
    .join('#');
};

export const parseQuerifiedFilters = (query: string): Filter[] => {
  if (query === '' || !query) {
    return [];
  }
  const providedFilters = query?.split('#').map((filterQuery) => {
    const filterParams = filterQuery.split('§');
    return {
      id: filterParams[0],
      selectedValues: filterParams[2]?.split('$') || []
    };
  });
  return providedFilters;
};

export const parseQuerifiedFiltersForRequest = (query: string): Filter[] => {
  if (query === '' || !query) {
    return [];
  }
  const providedFilters = query?.split('#').map((filterQuery) => {
    const filterParams = filterQuery.split('§');
    const filterType = filterParams[1];
    if (filterType === FilterTypes.Range) {
      const minMaxArray = filterParams[2]?.split('$') || [];
      return {
        id: filterParams[0],
        min: parseInt(minMaxArray[0], 10),
        max: parseInt(minMaxArray[1], 10)
      };
    }
    return {
      id: filterParams[0],
      valueIds: filterParams[2]?.split('$') || []
    };
  });
  return providedFilters;
};

// min and max included
export const randomIntFromInterval = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export const getLastItemsOfTheChunkedArray = (
  inputArray: { id: string }[],
  chunk: number
): string[] => {
  const result = [];
  for (let i = 0; i < inputArray?.length; i += chunk) {
    const temp = inputArray.slice(i, i + chunk);
    // do whatever
    result.push(temp[temp?.length - 1]?.id);
  }
  // Remove last item
  result.pop();
  return result;
};
